import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Leesritme',
    description: "Leesapp voor groep 1 tot en met 8. Elke dag een rijke tekst in de klas en thuis, als aanvulling op je leesmethode. Gratis pilot, zonder extra werk.",
    url: getOrigin(),
    ogImage: 'https://leesritme.cdn.modulify.website/images/leesritme-deelafbeelding.jpg'
}
